// removed by extract-text-webpack-plugin
module.exports = {"search__plus":"_30cywdbTcftNoFDHVm47iD","plus_icon":"_3zO37AlYA3yTYQMESA1HYv","tooltip":"_1qCIWtJYNyd0nZbE25RtQA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlusWidget/plusWidget.css
// module id = 542
// module chunks = 0